import { Injectable } from '@angular/core';
import { GooglebasechartService } from './googlebasechart.service';
import { LineChartConfig } from './linechartconfig';

declare var google: any;

@Injectable({
  providedIn: 'root'
})
export class GooglelinechartService extends GooglebasechartService {

  constructor() { super(); }
  public BuildLineChart(elementId: string, data: any[], config: LineChartConfig): void {
    var chartFunc = () => { return new google.visualization.LineChart(document.getElementById(elementId)); };
    let options
    if (config.colors) {
      options = {
        title: config.title,
        curveType: config.curveType,
        legend: { position: 'bottom' },
        colors: config.colors
      };
    } else {
      options = {
        title: config.title,
        curveType: config.curveType,
        legend: { position: 'bottom' }
      };
    }


    this.buildChart(data, chartFunc, options);
  }
}
